import { QueryClient } from '@tanstack/react-query';

/** A TanStack Query kliens — konzervatív default-ok egy B2B admin apphoz. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });
}
